<template>
  <div :class="wrapperClasses">
    <label class="exp-checkbox-label">
      <input
        :name="`ml-checkbox-${id}`"
        type="checkbox"
        :disabled="disabled"
        v-model="internalValue"
        @click="onClick"
      />
      <span class="exp-checkbox-custom"></span>
      <span v-if="text || title" class="exp-checkbox-text">
        {{ text || title }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'MemlistCheckbox',
  props: {
    id: { type: String, default: 'none' },
    disabled: { type: Boolean, default: false },
    value: { type: [Boolean, Number], default: 0 },
    numeric: { type: Boolean, default: false },
    text: { type: String, default: '' },
    title: { type: String, default: null },
    meta: { type: Object, default: null },
    variant: { type: String, default: 'blue' } // 'blue' | 'event'
  },
  emits: ['click', 'input', 'change'],
  data() {
    return { internalValue: this.toBool(this.value) };
  },
  watch: {
    value(v) { this.internalValue = this.toBool(v); },
    internalValue(v) {
      const out = this.numeric ? (v ? 1 : 0) : v;
      this.$emit('input',  out, this.meta);
      this.$emit('change', out, this.meta);
    }
  },
  methods: {
    toBool(v) { return v === 1 || v === true; },
    
    onClick(e) {
      this.$nextTick(() => {
        this.$emit('click', e);
      });
    }
  },
  computed: {
    wrapperClasses() {
      return [
        'exp-checkbox-wrapper',
        'ml-checkbox',
        { disabled: this.disabled },
        { 'variant-event': this.variant === 'event' }
      ];
    }
  }
};
</script>

<style scoped>
.exp-checkbox-wrapper{
  display:flex;
  align-items:center
}

.exp-checkbox-label{
  display:flex;
  align-items:center;
  cursor:pointer;
  position:relative
}

.exp-checkbox-label input{
  opacity:0;width:0;height:0
}

.exp-checkbox-custom{
  width:24px;height:24px;
  background:#fff;
  border:2px solid #0085eb;
  border-radius:4px;
  position:relative;
  transition:background .2s,border-color .2s
}

.exp-checkbox-label input:checked~.exp-checkbox-custom{
  background:#0085eb;border-color:#0085eb
}

.exp-checkbox-custom::after{
  content:"";
  position:absolute;
  display:none
}

.exp-checkbox-label input:checked~.exp-checkbox-custom::after{
  display:block
}

.exp-checkbox-custom::after{
  left:6px;top:2px;width:8px;height:12px;
  border:solid #fff;
  border-width:0 3px 3px 0;
  transform:rotate(45deg)
}

.exp-checkbox-text{margin-left:12px;font-size:13px}

/* disabled */
.exp-checkbox-wrapper.disabled{opacity:.6;cursor:not-allowed}
.exp-checkbox-wrapper.disabled .exp-checkbox-label{cursor:not-allowed}
.exp-checkbox-wrapper.disabled .exp-checkbox-custom{
  background:#f0f0f0;border-color:#ccc
}
.exp-checkbox-wrapper.disabled input:checked~.exp-checkbox-custom{
  background:#ccc;border-color:#ccc
}
.exp-checkbox-wrapper.disabled input:checked~.exp-checkbox-custom::after{
  border-color:#fff
}

/* variant: event */
.variant-event .exp-checkbox-custom{
  background:#eefcff;border-color:#35aaca
}
.variant-event input:checked~.exp-checkbox-custom{
  background:#35aaca;border-color:#35aaca
}
</style>
